"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewBookmarkOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.916 8.902A1.554 1.554 0 019.074 8.9l3.52 3.421V2.5H3.406v9.82l3.51-3.418zm1.08 1.064l4.982 4.843a.666.666 0 00.736.134.7.7 0 00.411-.643V1.7a.69.69 0 00-.68-.7H2.555a.69.69 0 00-.68.7v12.6a.7.7 0 00.411.643c.25.11.54.058.737-.134l4.973-4.843z",
    clipRule: "evenodd"
  })))
});
PreviewBookmarkOutlineIcon.displayName = 'PreviewBookmarkOutlineIcon';
var _default = exports.default = PreviewBookmarkOutlineIcon;